App.filter('isSameOrBeforeToday', ['moment', function (moment) {

    return function (dateString) {
        dateString = dateString || '';
        if (dateString) {
            return moment(new Date()).hour(0).minute(0).second(0).millisecond(0).isSameOrBefore(moment(dateString));
        }

        return false;
    };
}]);
